import NewsRequestMapper, { NEWS } from "./NewsRequestMapper";
import NewsResponseMappper from "./NewsResponseMappper";
class NewsStreamRepo {
    constructor(stream) {
        this.stream = stream;
        this.requestMapper = new NewsRequestMapper();
        this.responseMapper = new NewsResponseMappper();
        this.callback = [];
    }
    streamQuote(reqType, subscribe, cb) {
        this.manageStreamArray(subscribe, cb);
        const req = this.requestMapper.formatRequest(reqType, subscribe);
        const reqPayload = {
            payload: req,
            message: (e) => {
                this.streamRespCallback(e);
            },
        };
        this.stream.WSRequest(reqPayload);
    }
    async streamRespCallback(e) {
        if (this.isStreamTypeMatch(e)) {
            this.callback.map((cbs) => {
                this.responseMapper.formatResponse(e, cbs);
            });
        }
    }
    isStreamTypeMatch(data) {
        try {
            const ResData = JSON.parse(data);
            return ResData.response.streaming_type === NEWS;
        }
        catch (error) {
            return false;
        }
    }
    manageStreamArray(subscribe, cb) {
        const indexCb = this.callback.findIndex((cbi) => cbi.toString() == cb.toString());
        if (subscribe) {
            if (indexCb === -1) {
                this.callback.push(cb);
            }
        }
        else {
            if (indexCb > -1) {
                this.callback.splice(indexCb, 1);
            }
        }
    }
}
export default NewsStreamRepo;
